import { AllergensProps } from './types';
import { Body3, Box, Heading5, Space } from '@gousto-internal/citrus-react';

export function Allergens({ allergens }: AllergensProps) {
  return (
    <Box>
      <Heading5>Allergens</Heading5>
      <Space size={4} />
      {allergens.length > 0 && (
        <>
          <Body3 data-testid="recipe-specific-allergens">
            For allergens, see ingredients in <strong>BOLD. ({allergens.join(', ')})</strong>
          </Body3>
          <Space size={2} />
        </>
      )}
      <Body3 data-testid="additional-allergens-information">
        In addition to the recipe specific allergen information provided, due to production and
        packing methods Gousto boxes may also contain low levels of the following allergens: cereals
        containing gluten, crustaceans, eggs, fish, peanuts, soya, milk, nuts (almonds, hazelnuts,
        walnuts, cashews, pecan nuts, Brazil nuts, pistachio nuts, macadamia nuts), celery, sesame,
        sulphur dioxide and sulphites, lupin, molluscs, mustard
      </Body3>
    </Box>
  );
}
